(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faq-accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    // Initialize all FAQ accordions
    function initFaqAccordions() {
      const accordions = document.querySelectorAll('[data-faq-accordion]');

      accordions.forEach((accordion) => {
        // Skip if already initialized
        if (accordion.dataset.initialized === 'true') return;
        accordion.dataset.initialized = 'true';

        const allowMultiple = accordion.dataset.allowMultiple === 'true';
        const toggles = accordion.querySelectorAll('[data-faq-toggle]');

        toggles.forEach((toggle) => {
          toggle.addEventListener('click', function () {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            const answer = this.nextElementSibling;

            // Close other items if not allowing multiple
            if (!allowMultiple) {
              toggles.forEach((otherToggle) => {
                if (otherToggle !== this) {
                  otherToggle.setAttribute('aria-expanded', 'false');
                  const otherAnswer = otherToggle.nextElementSibling;
                  otherAnswer.classList.remove('is-active');
                  otherAnswer.style.padding = '0 0';
                }
              });
            }

            // Toggle current item
            if (isExpanded) {
              this.setAttribute('aria-expanded', 'false');
              answer.classList.remove('is-active');
              answer.style.padding = '0 0';
            } else {
              this.setAttribute('aria-expanded', 'true');
              answer.classList.add('is-active');
              answer.style.padding = '24px 0';
            }
          });
        });
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFaqAccordions);
    } else {
      initFaqAccordions();
    }

    // Re-initialize for Shopify section rendering
    document.addEventListener('shopify:section:load', initFaqAccordions);
  })();
  } catch(e) { console.error(e); }
})();

})();
